import React from 'react';
import ReactDOM from 'react-dom/client';
import {HashRouter , Routes, Route} from 'react-router-dom';
import './index.css';
// import App from './App';
import { AppProvider } from './context';
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import BookList from './Component/BookList/Booklist';
import BookDetails from './Component/BookDetails/BookDetails';
// import { HashRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppProvider>
  <HashRouter>
  <Routes>
    <Route path='/' element = {<Home />}>
      <Route path='about' element = {<About/>}/>
      <Route  path='book' element = {<BookList/>}/>
      <Route path='/book/:id' element ={<BookDetails/>}/>
    </Route>
  </Routes>
  </HashRouter>
  </AppProvider>
);

